import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
export default function ErrorSubmitDataAlert({ children }) {
	return (
		<Alert
			severity="warning"
			color="error"
			sx={{
				"& .MuiAlert-icon": {
					fontSize: 40,
				},
			}}
		>
			<AlertTitle variant="h4">Oups</AlertTitle>
			Une erreur est survenue lors de
			{" " + children}
		</Alert>
	);
}
